import { render, staticRenderFns } from "./CompanyMergeModal.vue?vue&type=template&id=38c5791b&"
import script from "./CompanyMergeModal.vue?vue&type=script&lang=js&"
export * from "./CompanyMergeModal.vue?vue&type=script&lang=js&"
import style0 from "./CompanyMergeModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports